<template>
<div>
  <v-row align="center" justify="center">
    <v-col>
      <v-card class="elevation-8 pt-12 pb-12 pl-6 pr-6">
        <v-img height="120" contain src="../../assets/Pelican_LogoB.png"></v-img>
        <center>
          <!-- 宅配單 常溫(#005a32) 低溫(#1976D2) 都不是(#000000)-->
          <div v-if="$cookie.get('dsmid_token').substr(1,2)==='01'">
            <b>
              <font face="微軟正黑體" size="5" color="#005a32">
                {{ $cookie.get('dsmid_token').substr(0,4) }}-{{ $cookie.get('dsmid_token').substr(4,4) }}-{{ $cookie.get('dsmid_token').substr(8,4) }}-{{ $cookie.get('dsmid_token').substr(12,3) }}
              </font> <br />
              <font face="微軟正黑體" size="5" color="#005a32">常溫單</font>
            </b>
          </div>
          <div v-else-if="$cookie.get('dsmid_token').substr(1,2)==='11'">
            <b>
              <font face="微軟正黑體" size="5" color="#1976D2">
                {{ $cookie.get('dsmid_token').substr(0,4) }}-{{ $cookie.get('dsmid_token').substr(4,4) }}-{{ $cookie.get('dsmid_token').substr(8,4) }}-{{ $cookie.get('dsmid_token').substr(12,3) }}
              </font> <br />
              <font face="微軟正黑體" size="5" color="#1976D2">低溫單</font>
            </b>
          </div>
          <div v-else>
            <b>
              <font face="微軟正黑體" size="5" color="#000000">
                {{ $cookie.get('dsmid_token').substr(0,4) }}-{{ $cookie.get('dsmid_token').substr(4,4) }}-{{ $cookie.get('dsmid_token').substr(8,4) }}-{{ $cookie.get('dsmid_token').substr(12,3) }}
              </font> <br />
              <font face="微軟正黑體" size="5" color="#000000"></font>
            </b>
          </div>
        </center><br />
        <div v-if="isCheckData===false">
          <!-- 寄件人資料區 常溫(#005a32 + #f0fff0) 低溫(#1976D2 + #ECF5FF)-->
          <div v-if="$cookie.get('dsmid_token').substr(1,2)==='01'">
            <v-card color="#005a32" class=" pt-2 pb-2">
              <center>
                <b>
                  <font face="微軟正黑體" size="5" color="#f0fff0">寄件人資料</font>
                </b>
              </center>
            </v-card>
            <v-card color="#f0fff0" class=" pt-3 pb-6">
              <b>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#005a32">客戶代號：</font>
                  <font face="微軟正黑體" size="4" color="#005a32">{{ $cookie.get('accountId') }}</font>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#005a32">客戶出貨單號：</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="16" background-color="#fff" style="height: 30px;  width: 275px;" v-model="inquiry_char" :rules="inquiry_char_R"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#005a32">寄件人名稱：</font>
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <v-col>
                    <v-text-field outlined dense maxlength="16" background-color="#fff" style="height: 30px;  width: 300px;" v-model="start_name" :rules="start_name_R"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#005a32">寄件人連絡電話</font>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#005a32">手機：</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="10" background-color="#fff" height="5" style="height: 30px;  width: 200px;" v-model="start_phone" :rules="start_phone_R"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#005a32">市話：</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="16" background-color="#fff" height="5" style="height: 30px;  width: 200px;" v-model="start_telphone" :rules="start_telphone_R" placeholder="例:02-12345678#分機"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#005a32">寄件人通訊地址</font>
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <SelectZipcode v-model="start_cityIdx" :options="start_cities" />&emsp;
                  <SelectZipcode v-model="start_areaIdx" :options="start_areas" />&emsp;
                  <div v-if="  start_zip === '' ">
                    <font face="微軟正黑體" size="4" color="#005a32">{{ start_zipcode }}</font>
                  </div>
                  <div v-else>
                    <font face="微軟正黑體" size="4" color="#005a32">{{ start_zip }}</font>
                  </div>
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <v-col>
                    <v-text-field outlined dense maxlength="24" background-color="#fff" height="5" style="height: 30px;  width: 400px;" v-model="start_address" :rules="start_address_R"></v-text-field>
                  </v-col>
                </v-row>
              </b>
            </v-card>
          </div>
          <div v-else-if="$cookie.get('dsmid_token').substr(1,2)==='11'">
            <v-card color="#1976D2" class=" pt-2 pb-2">
              <center>
                <b>
                  <font face="微軟正黑體" size="5" color="#ECF5FF">寄件人資料</font>
                </b>
              </center>
            </v-card>
            <v-card color="#ECF5FF" class=" pt-3 pb-6">
              <b>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#1976D2">客戶代號：</font>
                  <font face="微軟正黑體" size="4" color="#1976D2">{{ $cookie.get('accountId') }}</font>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#1976D2">客戶出貨單號：</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="16" background-color="#fff" style="height: 30px;  width: 275px;" v-model="inquiry_char" :rules="inquiry_char_R"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#1976D2">寄件人名稱：</font>
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <v-col>
                    <v-text-field outlined dense maxlength="16" background-color="#fff" style="height: 30px;  width: 300px;" v-model="start_name" :rules="start_name_R"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#1976D2">寄件人連絡電話</font>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#1976D2">手機：</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="10" background-color="#fff" height="5" style="height: 30px;  width: 200px;" v-model="start_phone" :rules="start_phone_R"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#1976D2">市話：</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="16" background-color="#fff" height="5" style="height: 30px;  width: 200px;" v-model="start_telphone" :rules="start_telphone_R" placeholder="例:02-12345678#分機"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#1976D2">寄件人通訊地址</font>
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <SelectZipcode v-model="start_cityIdx" :options="start_cities" />&emsp;
                  <SelectZipcode v-model="start_areaIdx" :options="start_areas" />&emsp;
                  <div v-if="  start_zip === '' ">
                    <font face="微軟正黑體" size="4" color="#1976D2">{{ start_zipcode }}</font>
                  </div>
                  <div v-else>
                    <font face="微軟正黑體" size="4" color="#1976D2">{{ start_zip }}</font>
                  </div>
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <v-col>
                    <v-text-field outlined dense maxlength="24" background-color="#fff" height="5" style="height: 30px;  width: 400px;" v-model="start_address" :rules="start_address_R"></v-text-field>
                  </v-col>
                </v-row>
              </b>
            </v-card>
          </div>
          <!-- 收件人資料區 (#ff9600 + #fff0f0) -->
          <v-card color="#ff9600" class=" pt-2 pb-2">
            <center>
              <b>
                <font face="微軟正黑體" size="5" color="#fff0f0">收件人資料</font>
              </b>
            </center>
          </v-card>
          <v-card color="#fff0f0" class=" pt-3 pb-6">
            <b>
              <v-row class="mb-3" no-gutters>
                &ensp;<font face="微軟正黑體" size="4" color="#ff9600">收件人名稱：</font>
              </v-row>
              <v-row class="mb-3" no-gutters>&ensp;
                <v-col>
                  <v-text-field outlined dense maxlength="16" background-color="#fff" style="height: 30px;  width: 300px;" v-model="end_name" :rules="end_name_R"></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;<font face="微軟正黑體" size="4" color="#ff9600">收件人連絡電話</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;<font face="微軟正黑體" size="4" color="#ff9600">手機：</font>
                <v-col>
                  <!--<v-text-field outlined dense maxlength="18" background-color="#fff" height="5" style="height: 30px;  width: 200px;" v-model="end_phone" :rules="end_phone_R"></v-text-field>-->
                  <v-text-field outlined dense maxlength="20" background-color="#fff" height="5" style="height: 30px;  width: 200px;" v-model="end_phone" :rules="end_phone_R"></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;<font face="微軟正黑體" size="4" color="#ff9600">市話：</font>
                <v-col>
                  <v-text-field outlined dense maxlength="16" background-color="#fff" height="5" style="height: 30px;  width: 200px;" v-model="end_telphone" :rules="end_telphone_R" placeholder="例:02-12345678#分機"></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;<font face="微軟正黑體" size="4" color="#ff9600">收件人通訊地址</font>
              </v-row>
              <v-row class="mb-3" no-gutters>&ensp;
                <SelectZipcode v-model="end_cityIdx" :options="end_cities" />&emsp;
                <SelectZipcode v-model="end_areaIdx" :options="end_areas" />
              </v-row>
              <v-row class="mb-3" no-gutters>&ensp;
                <v-col>
                  <v-text-field outlined dense maxlength="24" background-color="#fff" height="5" style="height: 30px;  width: 400px;" v-model="end_address" :rules="end_address_R"></v-text-field>
                </v-col>
              </v-row>
            </b>
          </v-card>
          <!-- 其他資料區 -->
          <div v-if="$cookie.get('dsmid_token').substr(1,2)==='01'">
            <v-card color="#005a32" class=" pt-3 pb-3">
              <br />
            </v-card>
            <v-card color="#DFFFDF" class=" pt-3 pb-6">
              <b>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#005a32">溫層：</font>
                  &ensp;<input type="radio" id="runoob" value="01" v-model="goods_type" style="height: 30px;  width: 30px;"><label for="runoob">
                    <font face="微軟正黑體" size="4" color="#005a32">常溫</font>
                  </label>
                  <!--&ensp;<input type="radio" id="runoob" value="02" v-model="goods_type" style="height: 30px;  width: 30px;" disabled><label for="runoob">
                    <font face="微軟正黑體" size="4" color="#005a32">冷凍</font>
                  </label>
                  &ensp;<input type="radio" id="runoob" value="03" v-model="goods_type" style="height: 30px;  width: 30px;" disabled><label for="runoob">
                    <font face="微軟正黑體" size="4" color="#005a32">冷藏</font>
                  </label>-->
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#005a32">寄件日：</font>
                  <v2-datepicker v-model="entry_date" lang="en" format="YYYY/MM/DD" value="new Date()" disabled></v2-datepicker>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#005a32">希望配達日：</font>
                  <v2-datepicker v-model="assign_date" lang="en" format="YYYY/MM/DD"></v2-datepicker>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#005a32">希望配達時段：</font>
                  <select v-model="assign_no">
                    <option value="00">不指定</option>
                    <option value="01">13時前</option>
                    <option value="02">14-18時</option>
                  </select>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#005a32">總件數：</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="2" background-color="#fff" height="5" style="height: 30px;  width: 50px;" v-model="ttl" :rules="ttl_R"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#005a32">代收付款方式：</font>
                  <select v-model="outspec_code">
                    <option value="0">&emsp;無代收款</option>
                    <option value="1">&emsp;現金</option>
                    <option value="2">&emsp;刷卡</option>
                  </select>
                </v-row>
                <div v-if="this.outspec_code==='0'">
                  <v-row class="mb-3" no-gutters>
                    &ensp;<font face="微軟正黑體" size="4" color="#005a32">代收金額：</font>
                    <v-col>
                      <v-text-field outlined dense maxlength="5" background-color="#fff" height="5" style="height: 30px;  width: 100px;" v-model="agency_receipt" :rules="agency_receipt_R" disabled></v-text-field>
                    </v-col>
                  </v-row>
                </div>
                <div v-else>
                  <v-row class="mb-3" no-gutters>
                    &ensp;<font face="微軟正黑體" size="4" color="#005a32">代收金額：</font>
                    <v-col>
                      <v-text-field outlined dense maxlength="6" background-color="#fff" height="5" style="height: 30px;  width: 100px;" v-model="agency_receipt" :rules="agency_receipt_R"></v-text-field>
                    </v-col>
                  </v-row>
                </div>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#005a32">內容物：</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="5" background-color="#fff" height="5" style="height: 30px;  width: 120px;" v-model="product" :rules="product_R"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#005a32">商品價值：</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="6" background-color="#fff" height="5" style="height: 30px;  width: 100px;" v-model="product_value" :rules="product_value_R"></v-text-field>
                  </v-col>
                </v-row>
                <!--<v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#005a32">備註(上限20字)：</font>
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <v-col>
                    <v-text-field outlined dense maxlength="20" background-color="#fff" height="5" style="height: 30px;  width: 400px;" v-model="reg_memo" :rules="reg_memo_R"></v-text-field>
                  </v-col>
                </v-row>-->
                <div v-if="this.roundtrio_type===true">
                  <v-row class="mb-3" no-gutters>
                    &ensp;<font face="微軟正黑體" size="4" color="#005a32">備註(上限17字)：</font>
                    &ensp;<font face="微軟正黑體" size="4" color="#005a32">來回件：</font>
                    <input type="checkbox" v-model="roundtrio_type">
                  </v-row>
                  <v-row class="mb-3" no-gutters>&ensp;
                    <v-col cols="auto" lg="1">
                      <font face="微軟正黑體" size="4" color="#005a32">來回-&ensp;</font>
                    </v-col>
                    <v-col>
                      <v-text-field outlined dense maxlength="17" background-color="#fff" height="5" style="height: 30px;  width: 347px;" v-model="reg_memo" :rules="reg_memo_R"></v-text-field>
                    </v-col>
                  </v-row>
                </div>
                <div v-else>
                  <v-row class="mb-3" no-gutters>
                    &ensp;<font face="微軟正黑體" size="4" color="#005a32">備註(上限20字)：</font>
                    &ensp;<font face="微軟正黑體" size="4" color="#005a32">來回件：</font>
                    <input type="checkbox" v-model="roundtrio_type">
                  </v-row>
                  <v-row class="mb-3" no-gutters>&ensp;
                    <v-col>
                      <v-text-field outlined dense maxlength="20" background-color="#fff" height="5" style="height: 30px;  width: 400px;" v-model="reg_memo" :rules="reg_memo_R"></v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </b>
            </v-card>
          </div>
          <div v-else-if="$cookie.get('dsmid_token').substr(1,2)==='11'">
            <v-card color="#1976D2" class=" pt-3 pb-3">
              <br />
            </v-card>
            <v-card color="#ECF5FF" class=" pt-3 pb-6">
              <b>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#1976D2">溫層：</font>
                  <!--&ensp;<input type="radio" id="runoob" value="01" v-model="goods_type" style="height: 30px;  width: 30px;" disabled><label for="runoob">
                    <font face="微軟正黑體" size="4" color="#1976D2">常溫</font>
                  </label>-->
                  &ensp;<input type="radio" id="runoob" value="02" v-model="goods_type" style="height: 30px;  width: 30px;"><label for="runoob">
                    <font face="微軟正黑體" size="4" color="#1976D2">冷凍</font>
                  </label>
                  &ensp;<input type="radio" id="runoob" value="03" v-model="goods_type" style="height: 30px;  width: 30px;"><label for="runoob">
                    <font face="微軟正黑體" size="4" color="#1976D2">冷藏</font>
                  </label>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#1976D2">寄件日：</font>
                  <v2-datepicker v-model="entry_date" lang="en" format="YYYY/MM/DD" value="new Date()" disabled></v2-datepicker>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#1976D2">希望配達日：</font>
                  <v2-datepicker v-model="assign_date" lang="en" format="YYYY/MM/DD"></v2-datepicker>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#1976D2">希望配達時段：</font>
                  <select v-model="assign_no">
                    <option value="00">不指定</option>
                    <option value="01">13時前</option>
                    <option value="02">14-18時</option>
                  </select>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#1976D2">總件數：</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="2" background-color="#fff" height="5" style="height: 30px;  width: 50px;" v-model="ttl" :rules="ttl_R"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#1976D2">代收付款方式：</font>
                  <select v-model="outspec_code">
                    <option value="0">&emsp;無代收款</option>
                    <option value="1">&emsp;現金</option>
                    <option value="2">&emsp;刷卡</option>
                  </select>
                </v-row>
                <div v-if="this.outspec_code==='0'">
                  <v-row class="mb-3" no-gutters>
                    &ensp;<font face="微軟正黑體" size="4" color="#1976D2">代收金額：</font>
                    <v-col>
                      <v-text-field outlined dense maxlength="5" background-color="#fff" height="5" style="height: 30px;  width: 100px;" v-model="agency_receipt" :rules="agency_receipt_R" disabled></v-text-field>
                    </v-col>
                  </v-row>
                </div>
                <div v-else>
                  <v-row class="mb-3" no-gutters>
                    &ensp;<font face="微軟正黑體" size="4" color="#1976D2">代收金額：</font>
                    <v-col>
                      <v-text-field outlined dense maxlength="6" background-color="#fff" height="5" style="height: 30px;  width: 100px;" v-model="agency_receipt" :rules="agency_receipt_R"></v-text-field>
                    </v-col>
                  </v-row>
                </div>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#1976D2">內容物：</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="5" background-color="#fff" height="5" style="height: 30px;  width: 100px;" v-model="product" :rules="product_R"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#1976D2">商品價值：</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="6" background-color="#fff" height="5" style="height: 30px;  width: 100px;" v-model="product_value" :rules="product_value_R"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#1976D2">備註(上限20字)：</font>
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <v-col>
                    <v-text-field outlined dense maxlength="20" background-color="#fff" height="5" style="height: 30px;  width: 400px;" v-model="reg_memo" :rules="reg_memo_R"></v-text-field>
                  </v-col>
                </v-row>
              </b>
            </v-card>
          </div>
          <br />
          <font face="微軟正黑體" size="3" color="#FF5252">提醒您：</font><br />
          <font face="微軟正黑體" size="4" color="#FF5252">1. 若寄件人相關資料有問題，請洽詢負責站所做修訂。</font><br />
          <font face="微軟正黑體" size="4" color="#FF5252">2. 若該訂單未於14日內取件，將自動清空填入資料。</font><br />
          <font face="微軟正黑體" size="4" color="#FF5252">3. 商品理賠上限為10,000元。</font><br />
          <div style="text-align:right">
            <div v-if="$cookie.get('dsmid_token').substr(1,2)==='01'">
              <v-btn color="success" x-large @click="btnChkData()">
                <font face="微軟正黑體" size="4">確定填寫資料</font>
              </v-btn>
            </div>
            <div v-else-if="$cookie.get('dsmid_token').substr(1,2)==='11'">
              <v-btn color="primary" x-large @click="btnChkData()">
                <font face="微軟正黑體" size="4">確定填寫資料</font>
              </v-btn>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-if="$cookie.get('dsmid_token').substr(1,2)==='01'">
            <v-card color="#005a32" class=" pt-3 pb-3">
              <center>
                <b>
                  <font face="微軟正黑體" size="5" color="#f0fff0">資料確認</font>
                </b>
              </center>
            </v-card>
            <v-card color="#f0fff0" class=" pt-3 pb-3">
              <v-row class="mb-3" no-gutters>
                <b>
                  &ensp;<font face="微軟正黑體" size="4" color="#005a32">寄件人</font>
                </b>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#005a32">客戶代號：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ $cookie.get('accountId') }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#005a32">名稱：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ start_name }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#005a32">電話：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ start_phone }}/{{ start_telphone }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#005a32">通訊地址：</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                <div v-if="start_cityIdx > 0">
                  &ensp;&ensp;<font face="微軟正黑體" size="4" color="#555555"> {{start_zip}}&ensp;{{ this.start_cities[start_cityIdx].name }}{{ this.start_areas[start_areaIdx].name }}{{ start_address }}
                  </font>
                </div>
                <div v-else>
                  &ensp;&ensp;<font face="微軟正黑體" size="4" color="#555555"> {{start_zipcode}}&ensp;{{ start_address }}
                  </font>
                </div>
              </v-row>
              <br />
              <v-row class="mb-3" no-gutters>
                <b>
                  &ensp;<font face="微軟正黑體" size="4" color="#005a32">收件人</font>
                </b>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#005a32">名稱：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ end_name }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#005a32">電話：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ end_phone }}/{{ end_telphone }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#005a32">通訊地址：</font><br />
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#555555"> {{end_zip}}&ensp;{{ this.end_cities[end_cityIdx].name }}&ensp;{{ this.end_areas[end_areaIdx].name }}&ensp;{{ end_address }}
                </font>
              </v-row>
              <br />
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#005a32">寄件日期：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ dateFormat(entry_date) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#005a32">希望配達日期：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ dateFormat(assign_date) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#005a32">希望配達時段：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ assign_no_name(assign_no) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#005a32">溫層：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ goods_type_name(goods_type) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#005a32">總件數：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ ttl }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#005a32">代收金額：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ agency_receipt }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#005a32">內容物：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ product }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#005a32">商品價值：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ product_value }}</font>
              </v-row>
              <!--<v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#005a32">備註：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ reg_memo }}</font>
              </v-row>-->
              <div v-if="this.roundtrio_type===true">
                <v-row class="mb-3" no-gutters>
                  &ensp;&ensp;<font face="微軟正黑體" size="4" color="#005a32">備註：</font>
                  <font face="微軟正黑體" size="4" color="#555555">來回-{{ reg_memo }}</font>
                </v-row>
              </div>
              <div v-else>
                <v-row class="mb-3" no-gutters>
                  &ensp;&ensp;<font face="微軟正黑體" size="4" color="#005a32">備註：</font>
                  <font face="微軟正黑體" size="4" color="#555555">{{ reg_memo }}</font>
                </v-row>
              </div>
              <center>
                <v-btn color="success" x-large @click="btnUpdData()">
                  <font face="微軟正黑體" size="4">返回修改</font>
                </v-btn>&ensp;
                <v-btn color="success" x-large @click="btnPostData()">
                  <font face="微軟正黑體" size="4">確定送出</font>
                </v-btn>
              </center>
            </v-card>
          </div>
          <div v-else-if="$cookie.get('dsmid_token').substr(1,2)==='11'">
            <v-card color="#1976D2" class=" pt-3 pb-3">
              <center>
                <b>
                  <font face="微軟正黑體" size="5" color="#ECF5FF">資料確認</font>
                </b>
              </center>
            </v-card>
            <v-card color="#ECF5FF" class=" pt-3 pb-3">
              <v-row class="mb-3" no-gutters>
                <b>
                  &ensp;<font face="微軟正黑體" size="4" color="#1976D2">寄件人</font>
                </b>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#1976D2">客戶代號：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ $cookie.get('accountId') }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#1976D2">名稱：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ start_name }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#1976D2">電話：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ start_phone }}/{{ start_telphone }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#1976D2">通訊地址：</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                <div v-if="start_cityIdx > 0">
                  &ensp;&ensp;<font face="微軟正黑體" size="4" color="#555555"> {{start_zip}}&ensp;{{ this.start_cities[start_cityIdx].name }}{{ this.start_areas[start_areaIdx].name }}{{ start_address }}
                  </font>
                </div>
                <div v-else>
                  &ensp;&ensp;<font face="微軟正黑體" size="4" color="#555555"> {{start_zipcode}}&ensp;{{ start_address }}
                  </font>
                </div>
              </v-row>
              <br />
              <v-row class="mb-3" no-gutters>
                <b>
                  &ensp;<font face="微軟正黑體" size="4" color="#1976D2">收件人</font>
                </b>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#1976D2">名稱：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ end_name }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#1976D2">電話：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ end_phone }}/{{ end_telphone }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#1976D2">通訊地址：</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#555555"> {{end_zip}}&ensp;{{ this.end_cities[end_cityIdx].name }}&ensp;{{ this.end_areas[end_areaIdx].name }}&ensp;{{ end_address }}
                </font>
              </v-row>
              <br />
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#1976D2">寄件日期：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ dateFormat(entry_date) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#1976D2">希望配達日期：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ dateFormat(assign_date) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#1976D2">希望配達時段：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ assign_no_name(assign_no) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#1976D2">溫層：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ goods_type_name(goods_type) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#1976D2">總件數：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ ttl }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#1976D2">代收金額：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ agency_receipt }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#1976D2">內容物：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ product }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#1976D2">商品價值：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ product_value }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#1976D2">備註：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ reg_memo }}</font>
              </v-row>

              <center>
                <v-btn color="primary" x-large @click="btnUpdData()">
                  <font face="微軟正黑體" size="4">返回修改</font>
                </v-btn>&emsp;
                <v-btn color="primary" x-large @click="btnPostData()">
                  <font face="微軟正黑體" size="4">確定送出</font>
                </v-btn>
              </center>
            </v-card>
          </div>
        </div>
      </v-card>
    </v-col>
  </v-row>
  <v-overlay :value="overlay">
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-overlay>
</div>
</template>

<script>
import SelectZipcode from "../../components/SelectZipcode";
import cities from "../../components/zipcode.json";

export default {
  components: {
    SelectZipcode,
  },
  data() {
    return {
      start_cityIdx: 0, //撈取寄件人縣市用
      start_areaIdx: 0, //撈取寄件人鄉政用
      end_cityIdx: 0, //撈取收件人縣市用
      end_areaIdx: 0, //撈取收件人鄉政用
      start_cityname: '',
      start_areaname: '',
      inquiry_char: '',
      inquiry_char_R: [
        (v) => {
          if (RegExp(/[\\/'"=&<>%]/).test(v.substr(-1, 1))) {
            this.inquiry_char = this.inquiry_char.substr(0, this.inquiry_char.length - 1);
            alert('請勿使用不合規則字元');
            return false
          } else {
            if (RegExp(/[\\/'"=&<>%]/).test(v)) {
              this.inquiry_char = '';
              alert('資料中有不合規則字元');
              return false
            }
            return true
          }
        },
      ],
      start_name: '', //寄件人姓名
      start_name_R: [
        (v) => {
          if (RegExp(/[\\/'"=&<>%]/).test(v.substr(-1, 1))) {
            this.start_name = this.start_name.substr(0, this.start_name.length - 1);
            alert('請勿使用不合規則字元');
            return false
          } else {
            if (RegExp(/[\\/'"=&<>%]/).test(v)) {
              this.start_name = '';
              alert('資料中有不合規則字元');
              return false
            }
            return true
          }
        },
      ],
      start_phone: '', //寄件人手機
      start_phone_R: [
        (v) => !!v || " ",
        (v) => {
          if (!RegExp(/^[0-9]*$/).test(v)) {
            this.start_phone = ''
          }
          return true
        },
      ],
      start_telphone: '', //寄件人市話
      start_telphone_R: [
        (v) => !!v || " ",
        (v) => {
          if (!RegExp(/^[0-9 \-#]*$/).test(v)) {
            this.start_telphone = ''
          }
          return true
        },
      ],
      start_zipcode: '',
      start_address: '', //寄件人地址
      start_address_R: [
        (v) => {
          if (RegExp(/[\\/'"=&<>%]/).test(v.substr(-1, 1))) {
            this.start_address = this.start_address.substr(0, this.start_address.length - 1);
            alert('請勿使用不合規則字元');
            return false
          } else {
            if (RegExp(/[\\/'"=&<>%]/).test(v)) {
              this.start_address = '';
              alert('資料中有不合規則字元');
              return false
            }
            return true
          }
        },
      ],
      end_name: '', //收件人姓名
      end_name_R: [
        (v) => {
          if (RegExp(/[\\/'"=&<>%]/).test(v.substr(-1, 1))) {
            this.end_name = this.end_name.substr(0, this.end_name.length - 1);
            alert('請勿使用不合規則字元');
            return false
          } else {
            if (RegExp(/[\\/'"=&<>%]/).test(v)) {
              this.end_name = '';
              alert('資料中有不合規則字元');
              return false
            }
            return true
          }
        },
      ],
      end_phone: '', //收件人手機
      end_phone_R: [
        (v) => !!v || " ",
        (v) => {
          if (!RegExp(/^[0-9 #]*$/).test(v)) {
            this.end_phone = ''
          }
          return true
        },
      ],
      end_telphone: '', //收件人市話
      end_telphone_R: [
        (v) => !!v || "",
        (v) => {
          if (!RegExp(/^[0-9 \-#]*$/).test(v)) {
            this.end_telphone = ''
          }
          return true
        },
      ],
      end_zipcode: '',
      end_address: '', //收件人地址
      end_address_R: [
        (v) => {
          if (RegExp(/[\\/'"=&<>%]/).test(v.substr(-1, 1))) {
            this.end_address = this.end_address.substr(0, this.end_address.length - 1);
            alert('請勿使用不合規則字元');
            return false
          } else {
            if (RegExp(/[\\/'"=&<>%]/).test(v)) {
              this.end_address = '';
              alert('資料中有不合規則字元');
              return false
            }
            return true
          }
        },
      ],
      goods_type: '', //溫層
      entry_date: new Date(), //寄件日
      assign_date: new Date(new Date().getTime() + 24 * 60 * 60 * 1000), //希望配答日
      assign_no: '00', //希望配達時段
      ttl: '1', //總件數
      ttl_R: [
        (v) => !!v || " ",
        (v) => {
          if (!RegExp(/^[0-9]*$/).test(v)) {
            this.ttl = ''
          }
          return true
        },
        (v) => {
          if (v > 20) {
            alert('總件數 最多20件')
          }
          return true
        },
        (v) => {
          if (v > 20) {
            this.ttl = ''
          }
          return true
        },
      ],
      outspec_code: '0', //代收款方式
      agency_receipt: '0', //代收款
      agency_receipt_R: [
        (v) => !!v || " ",
        (v) => {
          if (!RegExp(/^[0-9]*$/).test(v)) {
            this.agency_receipt = ''
          }
          return true
        },
        (v) => {
          if ((this.outspec_code === '1') && (v > 50001)) {
            alert('代收金額-現金 最大金額：5萬')
          }
          return true
        },
        (v) => {
          if ((this.outspec_code === '2') && (v > 200001)) {
            alert('代收金額-刷卡 最大金額：20萬')
          }
          return true
        },
      ],
      reg_memo: '', //備註
      reg_memo_R: [
        (v) => {
          if (RegExp(/[\\/'"=&<>]/).test(v.substr(-1, 1))) {
            this.reg_memo = this.reg_memo.substr(0, this.reg_memo.length - 1);
            alert('請勿使用不合規則字元');
            return false
          } else {
            if (RegExp(/[\\/'"=&<>]/).test(v)) {
              this.reg_memo = '';
              alert('資料中有不合規則字元');
              return false
            }
            return true
          }
        },
      ],
      product: '', //商品名
      product_R: [
        (v) => {
          if (RegExp(/[\\/'"=&<>%]/).test(v)) {
            this.product = '';
            alert('資料中有不合規則字元');
          }
          return true
        },
      ],
      product_value: '', //商品價值
      product_value_R: [
        (v) => !!v || " ",
        (v) => v < 10000 || " ",
        (v) => {
          if (!RegExp(/^[0-9]*$/).test(v)) {
            this.product_value = ''
          }
          return true
        },
      ],
      roundtrio_type: false,
      roundtrio_value: '0',
      isCheckData: false,
      overlay: false,
    };
  },
  mounted: function() {
    this.checkPage();
    this.goods_type_check();
    this.selectDSM();
  },
  computed: {
    start_cities() {
      return cities;
    },
    start_areas() {
      return cities[this.start_cityIdx].areas;
    },
    start_zip() {
      if ((this.start_areas[this.start_areaIdx].zip !== '') && (this.start_zipcode === '')) {
        this.start_address = '';
      }
      return this.start_areas[this.start_areaIdx].zip;
    },
    end_cities() {
      return cities;
    },
    end_areas() {
      return cities[this.end_cityIdx].areas;
    },
    end_zip() {
      return this.end_areas[this.end_areaIdx].zip;
    },
  },
  watch: {
    outspec_code(outspec_code) {
      if (outspec_code === '0') {
        this.agency_receipt = '0';
      }
    },
    roundtrio_type(roundtrio_type) {
      if ((roundtrio_type = true) && (this.reg_memo.length > 17)) {
        this.reg_memo = '';
      }
    },
  },
  methods: {
    checkPage: function() {
      if (this.$cookie.get('page_token') != 'S') {
        this.$router.push({
          name: "ErrorPage"
        });
      } else {
        let page_token = 'E';
        this.$cookie.set('page_token', page_token, "0");
      }
    },
    btnChkData: function() {
      if (this.start_zipcode === '') {
        this.start_zipcode = this.start_zip;
      }
      if ((this.start_name !== '') &&
        ((this.start_phone !== '') || (this.start_telphone !== '')) &&
        (this.start_zipcode !== '') &&
        (this.start_address !== '') &&
        (this.end_name !== '') &&
        ((this.end_phone !== '') || (this.end_telphone !== '')) &&
        //(this.end_zipcode !== '') &&
        (this.end_zip !== '') &&
        (this.end_address !== '') &&
        (this.goods_type !== '') &&
        (this.ttl !== '') &&
        (((this.outspec_code === '1') && (this.agency_receipt < 50001)) ||
          ((this.outspec_code === '2') && (this.agency_receipt < 200001)) ||
          ((this.outspec_code === '0') && (this.agency_receipt === '0'))) &&
        (this.product_value !== '')
      ) {
        if (this.product_value > 10000) {
          alert('提醒您!!商品理賠上限為10,000元!!');
        }
        this.isCheckData = true;
      } else {
        this.isCheckData = false;

        if ((this.start_name === '') ||
          ((this.start_phone === '') && (this.start_telphone === '')) ||
          (this.start_zipcode === '') ||
          (this.start_address === '')
        ) {
          alert('寄件人資料不完整');
        }
        if ((this.end_name === '') ||
          ((this.end_phone === '') && (this.end_telphone === '')) ||
          //(this.end_zipcode === '') ||
          (this.end_zip === '') ||
          (this.end_address === '')
        ) {
          alert('收件人資料不完整');
        }
        if (this.goods_type === '') {
          alert('請選擇溫層');
        }
        if (this.ttl === '') {
          alert('請輸入總件數');
        }
        if (((this.outspec_code === '1') && (this.agency_receipt > 50001)) ||
          ((this.outspec_code === '2') && (this.agency_receipt > 200001)) ||
          ((this.outspec_code === '0') && (this.agency_receipt !== '0'))
        ) {
          alert('代收金額有誤');
        }
        if (this.product_value === '') {
          alert('請輸入商品價值');
        }
      }
    },
    btnUpdData: function() {
      this.isCheckData = false;
    },
    btnPostData: function() {
      this.overlay = true;
      //let posturl = 'https://queryapi.e-can.com.tw:9091/EDIQRAPI/EDIQR_UpdData';
      let posturl = 'https://queryapi2.e-can.com.tw:9091/EDIQRAPI/EDIQR_UpdData';
      let axiosConfig = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      if (this.start_cityIdx === 0 || this.start_cityIdx === '0') {
        this.start_cityname = '';
      } else {
        this.start_cityname = this.start_cities[this.start_cityIdx].name;
        this.start_zipcode = this.start_zip;
      }
      if ((this.start_areaIdx === 0 || this.start_areaIdx === '0') && (this.start_cityIdx === 0 || this.start_cityIdx === '0')) {
        this.start_areaname = '';
      } else {
        this.start_areaname = this.start_areas[this.start_areaIdx].name;
      }
      if (this.start_areaname === '請選擇區域別') {
        this.start_areaname = '';
      }
      if (this.agency_receipt === '') {
        this.agency_receipt = '0';
      }
      //2023/03/09 addby Ray
      if (this.roundtrio_type === false) {
        this.roundtrio_value = '0';
      } else {
        this.roundtrio_value = '1';
      }

      let postdata = JSON.stringify({
        "utype": "upd",
        "main_id": this.$cookie.get('dsmid_token').substr(0, 12),
        "seq_id": this.$cookie.get('dsmid_token').substr(12, 3),
        "spec_id": "01", //2022/11/28 add by Ray
        "total_obj": this.ttl,
        "customer_delivery_date": "", //2022/11/28 add by Ray
        "cust_id": this.$cookie.get('accountId'),
        "delivery_sheet_date": "", //2022/11/28 add by Ray
        "company_no": "", //2022/11/28 add by Ray
        "inquiry_char": this.inquiry_char, //2022/11/28 add by Ray
        "start_name": this.start_name,
        "start_phone": this.start_phone,
        "start_telphone": this.start_telphone,
        "start_zpcode": this.start_zipcode,
        "start_cityno": this.start_cityIdx,
        "start_cityname": this.start_cityname,
        "start_areano": this.start_areaIdx,
        "start_areaname": this.start_areaname,
        "start_addr": this.start_address,
        "end_name": this.end_name,
        "end_phone": this.end_phone,
        "end_telphone": this.end_telphone,
        "end_zpcode": this.end_zip,
        "end_cityno": this.end_cityIdx,
        "end_cityname": this.end_cities[this.end_cityIdx].name,
        "end_areano": this.end_areaIdx,
        "end_areaname": this.end_areas[this.end_areaIdx].name,
        "end_addr": this.end_address,
        "assign_date": this.dateFormat(this.assign_date),
        "assign_no": this.assign_no,
        "original_carriage": "", //2022/11/28 add by Ray
        "agency_receipt": this.agency_receipt,
        "goods_type": this.goods_type,
        "input_type": "3",
        "src_type": "1",
        "pay_type": "1", //2022/11/28 add by Ray
        "delivery_record": "0", //2022/11/28 add by Ray
        "operator_id": "999999",
        "memo": this.reg_memo,
        "start_email": "", //2022/11/28 add by Ray
        "crg_memo": "",
        "print_code": "0",
        "seq_no": "1",
        "cust_seq_id": "01",
        "transfer_code": "0",
        "outspec_code": this.outspec_code,
        "pickup_price": "0",
        "receive_target": "2",
        "payment_target": "1",
        "product": this.product,
        "product_value": this.product_value,
        "effective_code": "1", //2022/11/28 add by Ray
        "roundtrio_type": this.roundtrio_value //2023/03/09 add by Ray
      });

      this.$cookie.set('start_name_token', this.start_name, "0");
      this.$cookie.set('start_phone_token', this.start_phone, "0");
      this.$cookie.set('start_telphone_token', this.start_telphone, "0");
      this.$cookie.set('start_zpcode_token', this.start_zipcode, "0");
      this.$cookie.set('start_cityno_token', this.start_cityIdx, "0");
      this.$cookie.set('start_cityname_token', this.start_cityname, "0");
      this.$cookie.set('start_areano_token', this.start_areaIdx, "0");
      this.$cookie.set('start_areaname_token', this.start_areaname, "0");
      this.$cookie.set('start_addr_token', this.start_address, "0");

      //let options = {
      //  method: 'POST',
      //  headers: {
      //    'content-type': 'application/json'
      //  },
      //  data: postdata,
      //  url: posturl,
      //};
      //this.$axios(options);
      //2023/04/10 post資料前增加單號狀態判斷 add by Ray
      let chkurl = 'https://queryapi2.e-can.com.tw:9091/EDIQRapi/EDIQR_ChkCust/cust_id=' + this.$cookie.get('accountId') + '&pass=' + this.$cookie.get('password') + '&main_id=' + this.$cookie.get('dsmid_token');
      this.$axios.get(chkurl).then(response => {
        this.custfilelst = response.data;
        //console.log(this.custfilelst);
        //this.overlay = false;
        if (response.data.cust === '1') {
          if (this.custfilelst.dsm === '1') {
            this.$axios.post(posturl, postdata, axiosConfig).then((response) => {
                if (response.data.pcode === '0') {
                  this.overlay = false;
                  alert('上傳失敗：' + response.data.desc);
                  this.$router.push({
                    name: "ErrorPage"
                  });
                } else if (response.data.pcode === '1') {
                  console.log(this.$cookie.get('dsmid_token').substr(0, 12) + '上傳成功');
                  this.overlay = false;
                  this.$router.push({
                    name: "EndPage"
                  });
                } else {
                  this.overlay = false;
                  alert('系統忙碌中，請稍後再試');
                  this.$router.push({
                    name: "ErrorPage"
                  });
                }
              })
              .catch((error) => {
                this.overlay = false;
                alert(error + '  ' + error.response);
                console.log(error);
                console.log(error.config);
                console.log(error.config.headers);
                this.$router.push({
                  name: "ErrorPage"
                });
              });
          } else if (this.custfilelst.dsm === '2') {
            this.overlay = false;
            alert('宅配單號已取件，無法更新');
            this.$router.push({
              name: "ErrorPage"
            });
          } else {
            this.overlay = false;
            alert('宅配單號更新失敗，請重新輸入dsm')
            this.$router.push({
              name: "ErrorPage"
            });
          }
        } else {
          this.overlay = false;
          alert('宅配單號更新失敗，請重新輸入psw');
          this.$router.push({
            name: "ErrorPage"
          });
        }
      }).catch(function(error) {
        this.overlay = false;
        this.$router.push({
          name: "ErrorPage"
        });
      });
      /*this.$axios.post(posturl, postdata, axiosConfig).then((response) => {
          if (response.data.pcode === '0') {
            this.overlay = false;
            alert('上傳失敗：' + response.data.desc);
            this.$router.push({
              name: "ErrorPage"
            });
          } else if (response.data.pcode === '1') {
            console.log(this.$cookie.get('dsmid_token').substr(0, 12) + '上傳成功');
            this.overlay = false;
            this.$router.push({
              name: "EndPage"
            });
          } else {
            this.overlay = false;
            alert('系統忙碌中，請稍後再試');
            this.$router.push({
              name: "ErrorPage"
            });
          }
        })
        .catch((error) => {
          this.overlay = false;
          //alert('上傳失敗，請稍後再重新送出');
          console.log(error);
          alert(error);
          this.$router.push({
            name: "ErrorPage"
          });
        });*/
    },

    selectDSM() {
      //let url = 'https://queryapi.e-can.com.tw:9091/EDIQRapi/EDIQR_Data/' + this.$cookie.get('dsmid_token').substr(0, 15);
      let url = 'https://queryapi2.e-can.com.tw:9091/EDIQRapi/EDIQR_Data/' + this.$cookie.get('dsmid_token').substr(0, 15);
      this.$axios.get(url).then(response => {
        this.dsmfilelst = response.data;

        this.inquiry_char = this.dsmfilelst.data[0].inquiry_char;
        this.start_name = this.dsmfilelst.data[0].start_name;
        this.start_cityIdx = this.dsmfilelst.data[0].start_cityno;
        this.start_areaIdx = this.dsmfilelst.data[0].start_areano;
        this.start_zipcode = this.dsmfilelst.data[0].start_zpcode;
        this.start_address = this.dsmfilelst.data[0].start_addr;
        this.start_phone = this.dsmfilelst.data[0].start_phone;
        this.start_telphone = this.dsmfilelst.data[0].start_telphone;
        this.end_name = this.dsmfilelst.data[0].end_name;
        this.end_cityIdx = this.dsmfilelst.data[0].end_cityno;
        this.end_areaIdx = this.dsmfilelst.data[0].end_areano;
        this.end_zip = this.dsmfilelst.data[0].end_zpcode;
        this.end_address = this.dsmfilelst.data[0].end_addr;
        this.end_phone = this.dsmfilelst.data[0].end_phone;
        this.end_telphone = this.dsmfilelst.data[0].end_telphone;
        this.goods_type = this.dsmfilelst.data[0].goods_type;
        if (this.dsmfilelst.data[0].assign_date === '') {
          this.assign_date = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
        } else {
          this.assign_date = new Date((this.dsmfilelst.data[0].assign_date).substr(0, 4) + '-' + (this.dsmfilelst.data[0].assign_date).substr(4, 2) + '-' + (this.dsmfilelst.data[0].assign_date).substr(6, 2));
        }
        this.assign_no = this.dsmfilelst.data[0].assign_no;
        this.ttl = this.dsmfilelst.data[0].totobj;
        this.outspec_code = this.dsmfilelst.data[0].outspec_code;
        this.agency_receipt = this.dsmfilelst.data[0].agency_receipt;
        this.reg_memo = this.dsmfilelst.data[0].memo;
        this.product = this.dsmfilelst.data[0].product;
        this.product_value = this.dsmfilelst.data[0].product_value;
        if (this.dsmfilelst.data[0].roundtrio_type === '1') {
          this.roundtrio_type = true;
        } else {
          this.roundtrio_type = false;
        }
      }).catch(function(error) {
        console.log(error);
      })

    },
    goods_type_check() {
      if (this.$cookie.get('dsmid_token').substr(1, 2) === '01') {
        this.goods_type = '01';
      } else {
        this.goods_type = '';
      }
    },
    goods_type_name(goods_type) {
      if (goods_type === '01') {
        return '常溫';
      } else if (goods_type === '02') {
        return '冷凍';
      } else if (goods_type === '03') {
        return '冷藏';
      } else {
        return '';
      }
    },
    assign_no_name(assign_no) {
      if (assign_no === '00') {
        return '不指定';
      } else if (assign_no === '01') {
        return '13時前';
      } else if (assign_no === '02') {
        return '14-18時';
      } else {
        return '';
      }
    },
    dateFormat(time) {
      let date = new Date(time);
      let year = date.getFullYear();
      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

      return year.toString() + month.toString() + day.toString();
    },
  },
};
</script>
